import { Stack } from "@mui/material";
import { Box } from "@mui/system";
import styled from "styled-components";
import { theme } from "styles/mui-config";
import ImgContainer from "components/shared/Image";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
export const StyledStack = styled(Stack)`
  background-color: ${theme.palette.secondary.light};
  border-radius: 4px;
  box-shadow: 0 0 5px ${theme.palette.shadow.main};
  & > div:first-child {
    margin: 0 auto;
  }
`;

export const StyledImg = styled.img`
  width: 250px;
  height: 100px;
  margin: 20px 0;
`;

export const StyledBoxContainer = styled(Box)`
  display: flex;
  align-items: start;
  justify-content: space-between;
  &:last-child {
    cursor: pointer;
  }
`;
export const StyledBox = styled(Box)`
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 8px;
  height: 81%;
  width: 100px;
  border-radius: 5px;
  border: 2px solid ${theme.palette.primary.main};
  font-size: 18px;
  letter-spacing: 2px;
  & > div {
    height: 100%;
  }
  & > div > img {
    height: 26px !important;
  }
`;

export const StyledImgContainer = styled(ImgContainer)`
  width: 600px;
  position: fixed;
  bottom: 0px;
  left: 33px;
  opacity: 20%;
  z-index: -1;
  @media (max-width: 900px) {
    width: 300px !important;
  }
`;
